module.exports = __webpack_public_path__ + "img/circle_transparent.b6e1f62d.png";